module.exports = __webpack_public_path__ + "components/weather-icon/static/nightheavysnow@2-6dad18721e9f0a64a21e3c8575160558.png";